import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TesmostaDatalistValidatorValue} from '../EnumsConstants/tesmosta-datalist-validator-value.enum';

@Pipe({
  name: 'summaryLabel',
  standalone: false,
  pure: false
})
export class SummaryLabelPipe implements PipeTransform {
  constructor(public translateService: TranslateService) {}

  transform(value: any): string {
    switch (value) {
      case TesmostaDatalistValidatorValue.UngueltigerWert:
        return this.translateService.instant('i18n.common.ungueltiger');
      case TesmostaDatalistValidatorValue.AuswertungAusgeschlossen:
        return this.translateService.instant('i18n.common.ausgeschlossen');
      case TesmostaDatalistValidatorValue.AuffaelligerWert:
        return this.translateService.instant('');
      case TesmostaDatalistValidatorValue.KorrektWert:
        return this.translateService.instant('i18n.common.gueltiger');
      default:
        return '-';
    }
  }
}
